export const environment = {
  production: true,
  httpBase: "",
};



// WEBPACK FOOTER //
// /var/snowriders/app/src/environments/environment.ts